/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard example components
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";

// Functions from store
import { getItemStatusReportHome } from "../../store";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const PdiItemStatusHomePageCard = ({
  getItemStatusReportHome,
  getItemStatusReportHomeReducer,
  startDate,
  endDate,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  const startDateIso = startDate ? startDate.toISOString().slice(0, 10) : "";

  const endDateIso = endDate ? endDate.toISOString().slice(0, 10) : "";

  useEffect(() => {
    getItemStatusReportHome(startDateIso, endDateIso, jwtToken);
  }, [startDateIso, endDateIso]);

  const [itemStatusData, setItemStatusData] = useState([]);

  const [itemStatusTitle, setItemStatusTitle] = useState("");

  useEffect(() => {
    let data = getItemStatusReportHomeReducer.itemStatus?.data
      ? getItemStatusReportHomeReducer.itemStatus.data
      : [];

    // alert("data: " + JSON.stringify(data));

    setItemStatusData(data);

    setItemStatusTitle(
      getItemStatusReportHomeReducer?.itemStatus?.queryMeta?.chartTitle ||
        "Item Status"
    );
  }, [getItemStatusReportHomeReducer]);

  const chartData = {
    labels: itemStatusData
      ? itemStatusData.map((data) => String(data.label))
      : [],
    datasets: {
      label: "Efficiency",
      data: itemStatusData
        ? itemStatusData.map((data) => String(data.value))
        : [],
    },
  };

  return (
    <ReportsBarChart
      color="error"
      title={itemStatusTitle}
      // date="Last updated 2 days ago"
      chart={chartData}
      // description="* in days"
    />
  );
};

const mapStateToProps = (state) => {
  return {
    getItemStatusReportHomeReducer: state.getItemStatusReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getItemStatusReportHome: (startDate, endDate, jwtToken) =>
      dispatch(getItemStatusReportHome(startDate, endDate, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PdiItemStatusHomePageCard);
